/**
 * Friend Stats Screen Styles
 * Page-level styles for app/app/friends/[friendId].tsx and FriendStatsLoadingSkeleton.
 * Component-level styles live in co-located *.styles.ts files.
 */

import { StyleSheet } from 'react-native';
import type { Theme } from '../src/theme/getTheme';
import { getTheme } from '../src/theme/getTheme';

export const getFriendStatsStyles = (theme: Theme) =>
  StyleSheet.create({
    /** Root container (passed as containerStyle to ScreenLayout). */
    screenLayoutContainer: {
      flex: 1,
      backgroundColor: theme.background.primary,
    },
    /** Generic flex container used by FriendStatsLoadingSkeleton. */
    container: {
      flex: 1,
      backgroundColor: 'transparent',
    },
    // === Screen header bar ===
    screenHeaderBar: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 16,
      paddingBottom: 8,
    },
    screenHeaderTitle: {
      fontSize: 13,
      fontWeight: '700',
      color: theme.gray[800],
      textTransform: 'uppercase',
      letterSpacing: 1.5,
    },
    screenHeaderAction: {
      width: 40,
      height: 40,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 20,
    },
    screenHeaderActionPressed: {
      opacity: 0.7,
    },
    screenHeaderActionHover: {
      opacity: 0.85,
    },
    // === Error state ===
    errorContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      padding: 32,
    },
    errorText: {
      fontSize: 16,
      color: theme.black,
      marginBottom: 16,
      textAlign: 'center',
      fontWeight: '600',
    },
    retryButton: {
      backgroundColor: theme.background.card,
      paddingHorizontal: 24,
      paddingVertical: 12,
      borderRadius: 12,
      shadowColor: theme.shadow,
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.2,
      shadowRadius: 8,
      elevation: 6,
    },
    retryButtonPressed: {
      opacity: 0.7,
    },
    retryButtonHover: {
      opacity: 0.9,
    },
    retryButtonText: {
      color: theme.primary,
      fontSize: 14,
      fontWeight: '700',
    },
  });

// Backward compatibility — export default styles using light theme
export const friendStatsStyles = getFriendStatsStyles(getTheme('light'));
